import { render, staticRenderFns } from "./bugForm.vue?vue&type=template&id=02c751b0"
import script from "./bugForm.vue?vue&type=script&lang=js"
export * from "./bugForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports